"use client";

import { ArrowRight, Layers, Palette, Sofa } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Wherestainlessisused() {
  const header = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const cardsReveal = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const pillars = [{
    number: "No 01",
    title: "INDUSTRIAL PRECISION",
    Icon: Palette,
    body: "We utilize advanced laser technology to ensure every mark meets rigorous industrial standards. Our process guarantees permanent, high-contrast identification for critical infrastructure.",
    italic: "Where durability meets engineering.",
    offset: "md:translate-y-0"
  }, {
    number: "No 02",
    title: "MATERIAL INTEGRITY",
    Icon: Layers,
    body: "From marine-grade stainless steel to high-impact phenolic, we source only the most resilient materials. Each substrate is tested for environmental resistance and long-term performance.",
    italic: "Quality is the foundation.",
    offset: "md:-translate-y-12"
  }, {
    number: "No 03",
    title: "COMPLIANCE STANDARDS",
    Icon: Sofa,
    body: "Our labeling solutions are engineered to satisfy UL 508A and OSHA requirements. We transform complex regulatory needs into clear, compliant, and professional identification systems.",
    italic: "Safety is our standard.",
    offset: "md:translate-y-12"
  }];
  return;
}